import { DeletionRequestsData } from '@recruitee/http/types';
import { createSingleEntityStore } from '@recruitee/ngrx';

import { EntityStoreKey } from '../../types';

const { actions, selectors, reducer, namespace } =
  createSingleEntityStore<DeletionRequestsData | null>()(EntityStoreKey.deletionRequests);

export {
  actions as DeletionRequestsActions,
  selectors as DeletionRequestsSelectors,
  reducer as DeletionRequestReducer,
  namespace as DeletionRequestNamespace,
};
